import template from './add-engin.html'
import css from './add-engin.less'
import css2 from './add-engin.css'
import { AddEnginController } from './add-engin.controller.js'

export const AddEnginComponent = {
  template: template,
  controller: AddEnginController,
  controllerAs: 'AddEnginController',
  require: {
    parentSimulator: '^^simulatorComponent',
    parentMouvement: '^^mouvement',
    //parentEditEchelon: '^^EditEchelonComponent' //add-echelon n'est pas toujours un child de edit-echelon (m...)
  },
  bindings: {
    doAddEchelon:'=',
    doRefreshEchelon:'=',
    doSave: '=',
    doCancel: '=', // Il est possible de donner une fonction a executer lors d'un cancel (facultatif)
    defineConsigneEchelons: '=',
    echelon: '=',
    codemouvement:'='
    /*,
    selectedEngin: '='*/ // pour l'édition d'engin (not used ! & conflit avec AddEnginController::selectedEngin )
  }
  /*,
    require: {
    parentMouvement: '^^mouvementComponent' //Error: [$compile:ctreq] Controller 'mouvementComponent', required by directive 'addEngin', can't be found!
  }*/
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/add-engin/add-engin.component.js